import { Box, Button, Card, CardContent, Container, Divider, Fade, FormControl, Grid, InputAdornment, InputLabel, MenuItem, Modal, OutlinedInput, Paper, Select, Table, TableCell, TableHead, TableRow, Typography } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Backdrop from '@material-ui/core/Backdrop';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { useDispatch } from 'react-redux';
import { ROL_USER, USER_ID } from '../../../app/api-client/constants';
import DatosTablaRegistroUsers from './datosTablaUsuarios';
import { totalUsers, createUsers } from '../../domain/api/UsersApi';
//estilos
const useStyles = makeStyles((theme) => ({
  root: {
    display: '1 0 auto',
    borderRadius: '18px',
    background: 'primary',

  },
  details: {
    display: 'flex',
    flexDirection: 'column',

  },
  content: {
    flex: 'auto',
    background: '#ffffff',
    display: 'flex',

  },
  cover: {
    width: 151,
  },
  controls: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  playIcon: {
    height: 38,
    width: 38,
  },
  contentContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  button: {
    marginLeft: 'auto',
    height: 50,
    width: 100,
    alignItems: 'center',
    justifyContent: 'center',
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '600px',
    margin: 'auto'

  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    borderRadius: '10px'
  },
  root2: {
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  input: {
    display: 'none',
  },
  root3: {
    display: '1 0 auto',
    borderRadius: '18px',
    background: process.env.REACT_APP_PRIMARY_THEMA,

  },
  hidden: {
    display: 'none',
  },
  TableCell: {
    color: '#0088FE',
    fontFamily: "'Segoe UI Variable Static Display 700', sans-serif",
    fontWeight: 'bold',
    fontSize: '20px',
    width: '25%',
    textAlign: 'center'

  },
  title: {
    marginBottom: '3%',
    marginTop: '1%',
    fontSize: '25px'
  },
  paper1: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
    width: '100%',
    marginTop: '2%'
  },


}));

export default function DatosRegistroUsuarios({ Lista, id }) {

  const [, id_user] = localStorage.getItem(USER_ID)
  const location = useLocation();
  const nameBascula = location.state?.nameBascula;
  const ubicacion = location.state?.ultimaConexion;
  const key = location.state?.key;


  //variables del año y los datos
  const ListaA = Lista
  const [year, setYear] = useState();
  const [Data, setData] = useState([]);
  useEffect(() => {
    setYear("");
  }, [])

  //cambio de año
  const handleChange = (e) => {
    setYear(e.target.value);
    getDataTable(id, e.target.value)

  };

  //se consume el servicio de listar
  const getDataTable = async (id, year) => {

    const dataList = await totalUsers(dispatch, id, year);
    try {
      setData(dataList.respuesta);
      ;

    } catch (err) {
      console.log("Ocurrio un error", err)
    }
  }


  const dispatch = useDispatch();
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [, setNewRegister] = useState([]);
  const [Mes, setMes] = useState("");
  const [total, setTotal] = useState("");


  const [, rol] = localStorage.getItem(ROL_USER)
  const handleOpen = () => {
    setOpen(true);

  };
  const handleClose = () => {
    setOpen(false);
    userForm()
  };
  const userForm = () => {
    setMes("");
    setTotal("");
  
  };
  //crear 

  const create = async () => {
    let Request =
    {
      evbi: id,
      mes: Mes,
      year: year,
      total: total
    }


    const [, responseAsigned] = await createUsers(dispatch, Request)
    try {
      // setNewRegister(responseAsigned.codigoRespuesta);
      handleClose();
      userForm();
      getDataTable(id, year);
      setYear("");
      setTotal("");
      setMes("")
    } catch (err) {
      console.log("Ocurrio un error", err)
    }

  }
  const theme = useTheme(); // Obtén el tema

  const primaryColor = theme.palette.primary.main;

  return (
    <>
      <Card className={classes.root}>
        <div className={classes.details}>
          <Container className={classes.contentContainer} style={{ marginLeft: '15px', backgroundColor: '#ffffff' }}>
            <CardContent className={classes.content}>
              <Grid>
                <Typography component="h6" variant="h6">
                  Evbi
                </Typography>
                <Typography variant="subtitle1" color="textSecondary">{nameBascula ? nameBascula : "--"}</Typography>
              </Grid>
              <Divider style={{ marginLeft: '1%', background: '#D9D9D9' }} orientation="vertical" flexItem />
              <Grid style={{ marginLeft: '15px' }}>
                <Typography component="h6" variant="h6">
                  Ubicación
                </Typography>
                <Typography variant="subtitle1" color="textSecondary">{ubicacion}</Typography>
              </Grid>

              <Divider style={{ marginLeft: '1%', background: '#D9D9D9' }} orientation="vertical" flexItem />

              <Grid style={{ marginLeft: '15px' }}>
                <Typography component="h6" variant="h6">
                  Key
                </Typography>
                <Typography variant="subtitle1" color="textSecondary">{key ? key : "--"}</Typography>
              </Grid>
              <Divider style={{ marginLeft: '1%', background: '#D9D9D9', marginRight: '3%' }} orientation="vertical" flexItem />


              <Box sx={{ minWidth: 120 }}>

                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">AÑO</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={year}
                    label="year"
                    onChange={handleChange}
                    startAdornment={<InputAdornment position="start"></InputAdornment>}

                  >

                    {

                      ListaA.map(opcion => {
                        return (
                          <MenuItem value={opcion.year}>{opcion.year}</MenuItem>
                        );
                      })
                    }
                  </Select>

                </FormControl>
              </Box>


            </CardContent>

            <Button
              variant="contained"
              color="primary"
              component="span"
              disabled={year === ""}
              onClick={handleOpen}
              style={{ borderRadius: '10px' }}
            >CREAR NUEVO REGISTRO</Button>

          </Container>

        </div>
      </Card>

      <div>

        <Modal
          className={classes.modal}
          open={open}
          onClose={handleClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={open}>
            <div className={classes.paper}>
              <Container>

                <Grid item xs={12} md={12} sm={12} style={{ marginTop: '2rem' }} >
                  <FormControl fullWidth variant="outlined">
                    <InputLabel htmlFor="Mes" style={{ fontWeight: "bold", fontSize: '18px' }}>MES*</InputLabel>
                    <Select
                      labelId="demo-simple-select-outlined-label"
                      id="Mes"
                      name="Mes"
                      value={Mes}
                      style={{ fontSize: '18px', borderRadius: '10px' }}
                      onChange={e => {
                        setMes(e.target.value)
                      }}
                      label="Tipo de actividad"
                      startAdornment={<InputAdornment position="start">-</InputAdornment>}
                    >
                      <MenuItem value="">
                        <em>Seleciona un Mes</em>
                      </MenuItem>
                      <MenuItem value="Enero">ENERO</MenuItem>
                      <MenuItem value="Febrero">FEBRERO</MenuItem>
                      <MenuItem value="Marzo">MARZO</MenuItem>
                      <MenuItem value="Abril">ABRIL</MenuItem>
                      <MenuItem value="Mayo">MAYO</MenuItem>
                      <MenuItem value="Junio">JUNIO</MenuItem>
                      <MenuItem value="Julio">JULIO</MenuItem>
                      <MenuItem value="Agosto">AGOSTO</MenuItem>
                      <MenuItem value="Septiembre">SEPTIEMBRE</MenuItem>
                      <MenuItem value="Octubre">OCTUBRE</MenuItem>
                      <MenuItem value="Noviembre">NOVIEMBRE</MenuItem>
                      <MenuItem value="Diciembre">DICIEMBRE</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid container spacing={2} style={{ marginTop: '10px' }}>
                  <Grid item xs={12} md={6}>
                    <FormControl fullWidth variant="outlined">
                      <InputLabel htmlFor="totalUsers" shrink style={{ fontWeight: "bold", fontSize: '18px' }}>Total usuarios*</InputLabel>
                      <OutlinedInput
                        id="totalUsers"
                        style={{ fontSize: '18px', borderRadius: '10px' }}
                        type="total"
                        name='totalUsers'
                        value={total}
                        onChange={e => {
                          setTotal(e.target.value);
                        }}
                        startAdornment={<InputAdornment position="start">-</InputAdornment>}
                        label="totalUsers"
                        autoComplete='off'
                      />
                    </FormControl>
                  </Grid>
                </Grid>




                <Grid item xs={12} style={{ textAlign: "center", marginTop: '2rem', display: 'flex', justifyContent: 'center' }}>
                  <Button
                    variant="contained"
                    color="primary"
                    type="button"
                    onClick={create}
                    disabled={
                      !Mes ||
                      !total
                    }
                    style={{ borderRadius: '10px' }}
                  >
                    Guardar
                  </Button>
                  <Button
                    style={{ marginLeft: '10px', borderRadius: '10px' }}
                    variant="contained"
                    color='primary'
                    type="button"
                    onClick={handleClose}
                  >
                    Cancelar
                  </Button>
                </Grid>

              </Container>
            </div>
          </Fade>
        </Modal>
        <Paper className={classes.paper1} >
          <div>
            <Typography variant="h4" className={classes.title} color='primary'>
              Total de usuarios año: {year}
            </Typography>
            {/* Encabezados de la tabla */}
            <Table>
              <TableHead color='primary'>
                <TableRow color='primary'>
                  <TableCell className={classes.TableCell} style={{color:primaryColor}} >Mes</TableCell>
                  <TableCell className={classes.TableCell} style={{color:primaryColor}}>Numero de usuarios</TableCell>
                  <TableCell className={classes.TableCell} style={{color:primaryColor}}>Fecha actualizacion</TableCell>
                  <TableCell className={classes.TableCell} style={{color:primaryColor}}></TableCell>
                </TableRow>
              </TableHead>
            </Table>

            <Grid item xs={12}>
              <DatosTablaRegistroUsers
                year={year}
                resultado={Data}
                nameBascula={nameBascula}
                ListaA={ListaA}
                ID={id}
                reload={getDataTable}
                primaryColor={primaryColor}>
                  
              </DatosTablaRegistroUsers>
            </Grid>


          </div>
        </Paper>

      </div>


    </>
  );


}